
// components
import { CardsByWeek } from './cards-by-week';

const WEEKS = [
    { label: 'Week 1', color: 'week1' },
    { label: 'Week 2', color: 'week2' },
    { label: 'Week 3', color: 'week3' },
    { label: 'Week 4', color: 'week4' }
]
const ShipmentCards = ({ data, onChange }) => {
    if (!data) {
        return (
            <div className="mt-3">
                <article className="message is-link mt-2 p-6">
                    <div className="message-body">
                        No shipments have been scheduled yet for this month.
                    </div>
                </article>
            </div>
        )
    };

    return (
        WEEKS.map((week) => (
            <CardsByWeek week={week} data={data[week.label]} key={`key-${week.label}`} />
        )));

}

export { ShipmentCards };
